import React from 'react';
import i18n from '../../../../../translations/strings';
import { Colors } from '../../../../../colors';
import {
  getDisplayNameStatusBooking,
  getStringDateName,
} from '../../../../../utils/utils';
import { TableDetailReservationStyled } from './table-detail-reservation.styled';
import { SvgImage, SvgType } from '../../../../../components/base/svg/svg';
import { useModal } from '../../../../../components/shared/modal-provider/hooks/modal-provider.hook';
import { ModalVariant } from '../../../../../components/shared/modal-provider/components/modal/modal.constants';
import LinearLoading from '../../../../../components/base/loading/linear-loading/linear-loading';
import ClickableTextProps from '../../../../../components/base/clickable-text/clickable-text';
import { ListStyled } from '../../../../../components/shared/list/list.styled';

export interface TableDetailReservationsProps {
  reservation: any;
  handleAddAdminNotes: (message: string) => void;
  setShowMakeReservation: any;
  loading: boolean;
  onClickEmail: (selectedReservation: any) => void;
}

const TableDetailReservations = (props: TableDetailReservationsProps) => {
  const { reservation } = props;

  console.log(reservation)

  const { openModal } = useModal();

  return (
    <TableDetailReservationStyled.TableContainer container>
      <LinearLoading loading={props.loading} />
      {reservation && (
        <TableDetailReservationStyled.ReservationDetails container item xs={12}>
          <TableDetailReservationStyled.Header>
            <TableDetailReservationStyled.HeaderTitleContainer>
              <TableDetailReservationStyled.HeaderTitle>
                {i18n.t('handleReservation.reservationSummaryTitle')}
              </TableDetailReservationStyled.HeaderTitle>

            </TableDetailReservationStyled.HeaderTitleContainer>
            <TableDetailReservationStyled.HeaderButtons>
              <ClickableTextProps
                clickableText={i18n.t(
                  'handleReservation.sendMessageToClaimant',
                )}
                iconLeft={SvgType.MailNotFill}
                iconLeftMarginRight="8px"
                styled={{
                  color: Colors.Black,
                  fontFamily: 'EncodeSans-Regular',
                  fontSize: '10px',
                }}
                onClick={() => props.onClickEmail(reservation)}
              />
              <ClickableTextProps
                clickableText={i18n.t('handleReservation.addAdminNote')}
                iconLeft={SvgType.Note}
                iconLeftMarginRight="8px"
                styled={{
                  color: Colors.Black,
                  fontFamily: 'EncodeSans-Regular',
                  fontSize: '10px',
                }}
                onClick={() =>
                  openModal({
                    message: i18n.t('handleReservation.messageAdminNotesModal'),
                    variant: ModalVariant.PlainTextPicker,
                    onConfirmClick: props.handleAddAdminNotes,
                  })
                }
              />
            </TableDetailReservationStyled.HeaderButtons>
          </TableDetailReservationStyled.Header>

          <TableDetailReservationStyled.Divider />

          <TableDetailReservationStyled.ContentDetailsContainer>
            <TableDetailReservationStyled.ColumnDetails>
              {reservation.status && (
                <TableDetailReservationStyled.FieldDetailContainer>
                  <TableDetailReservationStyled.FieldDetailLabel>
                    {i18n.t('handleReservation.statusLabel')}
                  </TableDetailReservationStyled.FieldDetailLabel>
                  <TableDetailReservationStyled.ReservationStatusShape
                    reservationStatus={reservation.status}
                  >
                    <TableDetailReservationStyled.FieldDetailValue
                      style={{ color: Colors.White }}
                    >
                      {getDisplayNameStatusBooking(reservation.status)}
                    </TableDetailReservationStyled.FieldDetailValue>
                  </TableDetailReservationStyled.ReservationStatusShape>
                </TableDetailReservationStyled.FieldDetailContainer>
              )}

              {reservation.id && (
                <>
                  <TableDetailReservationStyled.Divider />
                  <TableDetailReservationStyled.FieldDetailContainer>
                    <TableDetailReservationStyled.FieldDetailLabel>
                      {i18n.t('handleReservation.reservationIdLabel')}
                    </TableDetailReservationStyled.FieldDetailLabel>
                    <TableDetailReservationStyled.FieldDetailValue>
                      {reservation.reference_number ? reservation.reference_number : reservation.id}
                    </TableDetailReservationStyled.FieldDetailValue>
                  </TableDetailReservationStyled.FieldDetailContainer>
                </>
              )}

              {reservation.created_at && (
                <>
                  <TableDetailReservationStyled.Divider />
                  <TableDetailReservationStyled.FieldDetailContainer>
                    <TableDetailReservationStyled.FieldDetailLabel>
                      {i18n.t('handleReservation.reservationDateLabel')}
                    </TableDetailReservationStyled.FieldDetailLabel>
                    <TableDetailReservationStyled.FieldDetailValue>
                      {getStringDateName(reservation.created_at)}
                    </TableDetailReservationStyled.FieldDetailValue>
                  </TableDetailReservationStyled.FieldDetailContainer>
                </>
              )}

              {reservation.user_information?.vat_number && (
                <>
                  <TableDetailReservationStyled.Divider />
                  <TableDetailReservationStyled.FieldDetailContainer>
                    <TableDetailReservationStyled.FieldDetailLabel>
                      {i18n.t('handleReservation.vatNumber')}{' '}
                    </TableDetailReservationStyled.FieldDetailLabel>
                    <TableDetailReservationStyled.FieldDetailValue>
                      {reservation.user_information?.vat_number}
                    </TableDetailReservationStyled.FieldDetailValue>
                  </TableDetailReservationStyled.FieldDetailContainer>
                </>
              )}

              {reservation.user_information?.tax_code && (
                <>
                  <TableDetailReservationStyled.Divider />
                  <TableDetailReservationStyled.FieldDetailContainer>
                    <TableDetailReservationStyled.FieldDetailLabel>
                      {i18n.t('handleReservation.taxCode')}{' '}
                    </TableDetailReservationStyled.FieldDetailLabel>
                    <TableDetailReservationStyled.FieldDetailValue>
                      {reservation.user_information?.tax_code}
                    </TableDetailReservationStyled.FieldDetailValue>
                  </TableDetailReservationStyled.FieldDetailContainer>
                </>
              )}
            </TableDetailReservationStyled.ColumnDetails>

            <TableDetailReservationStyled.ColumnDetails>
              {reservation.user_information?.first_name && (
                <>
                  <TableDetailReservationStyled.FieldDetailContainer>
                    <TableDetailReservationStyled.FieldDetailLabel>
                      {i18n.t('handleReservation.claimantLabel')}
                    </TableDetailReservationStyled.FieldDetailLabel>
                    <TableDetailReservationStyled.FieldDetailValue>
                      {reservation.user_information?.first_name}{' '}
                      {reservation.user_information?.last_name}
                    </TableDetailReservationStyled.FieldDetailValue>
                  </TableDetailReservationStyled.FieldDetailContainer>
                </>
              )}

              {reservation.user_information?.phone_number && (
                <>
                  <TableDetailReservationStyled.Divider />
                  <TableDetailReservationStyled.FieldDetailContainer>
                    <TableDetailReservationStyled.FieldDetailLabel>
                      {i18n.t('handleReservation.claimantPhoneLabel')}
                    </TableDetailReservationStyled.FieldDetailLabel>
                    <TableDetailReservationStyled.FieldDetailValue>
                      {reservation.user_information?.phone_number}
                    </TableDetailReservationStyled.FieldDetailValue>
                  </TableDetailReservationStyled.FieldDetailContainer>
                </>
              )}

              {reservation.user_information?.business_email && (
                <>
                  <TableDetailReservationStyled.Divider />
                  <TableDetailReservationStyled.FieldDetailContainer>
                    <TableDetailReservationStyled.FieldDetailLabel>
                      {i18n.t('handleReservation.businessEmail')}
                    </TableDetailReservationStyled.FieldDetailLabel>
                    <TableDetailReservationStyled.FieldDetailValue>
                      {reservation.user_information?.business_email}
                    </TableDetailReservationStyled.FieldDetailValue>
                  </TableDetailReservationStyled.FieldDetailContainer>
                </>
              )}

              {reservation.user_information?.business_unique_code && (
                <>
                  <TableDetailReservationStyled.Divider />
                  <TableDetailReservationStyled.FieldDetailContainer>
                    <TableDetailReservationStyled.FieldDetailLabel>
                      {i18n.t('handleReservation.businessUniqueCode')}{' '}
                    </TableDetailReservationStyled.FieldDetailLabel>
                    <TableDetailReservationStyled.FieldDetailValue>
                      {reservation.user_information?.business_unique_code}
                    </TableDetailReservationStyled.FieldDetailValue>
                  </TableDetailReservationStyled.FieldDetailContainer>
                </>
              )}

              {reservation.user_information?.business_name && (
                <>
                  <TableDetailReservationStyled.Divider />
                  <TableDetailReservationStyled.FieldDetailContainer>
                    <TableDetailReservationStyled.FieldDetailLabel>
                      {i18n.t('handleReservation.businessName')}{' '}
                    </TableDetailReservationStyled.FieldDetailLabel>
                    <TableDetailReservationStyled.FieldDetailValue>
                      {reservation.user_information?.business_name}
                    </TableDetailReservationStyled.FieldDetailValue>
                  </TableDetailReservationStyled.FieldDetailContainer>
                </>
              )}

              {reservation.user_information?.business_address && (
                <>
                  <TableDetailReservationStyled.Divider />
                  <TableDetailReservationStyled.FieldDetailContainer>
                    <TableDetailReservationStyled.FieldDetailLabel>
                      {i18n.t('handleReservation.businessAddress')}{' '}
                    </TableDetailReservationStyled.FieldDetailLabel>
                    <TableDetailReservationStyled.FieldDetailValue>
                      {reservation.user_information?.business_name}
                    </TableDetailReservationStyled.FieldDetailValue>
                  </TableDetailReservationStyled.FieldDetailContainer>
                </>
              )}
            </TableDetailReservationStyled.ColumnDetails>

            <TableDetailReservationStyled.ColumnDetails>
              {reservation?.notes && (
                <>
                  <TableDetailReservationStyled.FieldDetailLabel
                    style={{ marginBottom: '11px' }}
                  >
                    {i18n.t('handleReservation.claimantNotesLabel')}
                  </TableDetailReservationStyled.FieldDetailLabel>
                  <TableDetailReservationStyled.FieldDetailValue>
                    {reservation?.notes}
                  </TableDetailReservationStyled.FieldDetailValue>
                </>
              )}
              {reservation.admin_notes && (
                <>
                  <TableDetailReservationStyled.FieldDetailLabel
                    style={{ marginBottom: '11px' }}
                  >
                    {i18n.t('handleReservation.adminNotesLabel')}
                  </TableDetailReservationStyled.FieldDetailLabel>
                  <TableDetailReservationStyled.FieldDetailValue>
                    {reservation.admin_notes}
                  </TableDetailReservationStyled.FieldDetailValue>
                </>
              )}
            </TableDetailReservationStyled.ColumnDetails>
          </TableDetailReservationStyled.ContentDetailsContainer>
        </TableDetailReservationStyled.ReservationDetails>
      )}
    </TableDetailReservationStyled.TableContainer>
  );
};

export default TableDetailReservations;
